// Little Steps buy box: variant selection, offer tiers, gallery dots/thumbs, size guide dialog, sticky ATC.
(function () {
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  document.querySelectorAll('.ls-pdp').forEach(function (root) {
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var fmt = root.dataset.moneyFormat;
    var pricePlaceholder = root.dataset.pricePlaceholder;
    var idInput = root.querySelector('.product-variant-id');
    var qtyInput = root.querySelector('[data-qty-input]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var atcText = atcLabel ? atcLabel.textContent : '';
    var slides = root.querySelector('.ls-pdp__slides');

    // Variant selection
    var fieldsets = root.querySelectorAll('.ls-pdp__option');
    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) { var s = fs.querySelector('[data-selected]'); if (s) s.textContent = sel[i]; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v || !idInput) return;
      idInput.value = v.id;
      var price = root.querySelector('[data-price]');
      if (price && !pricePlaceholder) price.textContent = money(v.price, fmt);
      var was = root.querySelector('[data-compare]');
      if (was) { was.hidden = !(v.compare_at_price > v.price) || !!pricePlaceholder; was.textContent = money(v.compare_at_price || 0, fmt); }
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? atcText : (window.variantStrings ? window.variantStrings.soldOut : 'Sold out');
      }
      var sv = root.querySelector('[data-sticky-variant]');
      if (sv) sv.textContent = v.title;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
      if (v.featured_media && slides) {
        var target = slides.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (target) slides.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

    // Offer tiers set the quantity
    root.querySelectorAll('[data-qty]').forEach(function (r) {
      r.addEventListener('change', function () { if (qtyInput) qtyInput.value = r.value; });
    });

    // Gallery counter + thumbnails
    if (slides) {
      var current = root.querySelector('[data-current]');
      var thumbs = root.querySelectorAll('[data-go]');
      var tick;
      slides.addEventListener('scroll', function () {
        cancelAnimationFrame(tick);
        tick = requestAnimationFrame(function () {
          var i = Math.round(slides.scrollLeft / slides.clientWidth);
          if (current) current.textContent = i + 1;
          thumbs.forEach(function (t) { t.toggleAttribute('aria-current', +t.dataset.go === i); });
        });
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { slides.scrollTo({ left: slides.clientWidth * +t.dataset.go, behavior: 'smooth' }); });
      });
    }

    // Size guide
    var guide = root.querySelector('[data-guide]');
    root.querySelectorAll('[data-open-guide]').forEach(function (b) {
      b.addEventListener('click', function () { if (guide && guide.showModal) guide.showModal(); });
    });
    if (guide) {
      guide.querySelector('[data-close-guide]').addEventListener('click', function () { guide.close(); });
      guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
    }

    // Sticky ATC: shows once the main button has scrolled out of view (mobile only via CSS)
    var sticky = root.querySelector('[data-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }).observe(atc);
      sticky.querySelector('[data-sticky-btn]').addEventListener('click', function () { atc.click(); });
    }
  });
})();
